import { AnimationBuilder } from '@angular/animations';
import {
  AfterViewInit,
  Directive,
  ElementRef,
  Input,
  inject,
} from '@angular/core';
import {
  collapseAnimation,
  expandAnimation,
} from '@shared/constants/expand-collapse.animation';
import { AccordionItem } from '@shared/models/accordion-item';

@Directive({
  standalone: false,
  selector: '[gstarExpandCollapse]',
})
export class ExpandCollapseDirective implements AfterViewInit {
  private el = inject(ElementRef);
  private builder = inject(AnimationBuilder);

  @Input() gstarExpandCollapse!: AccordionItem;

  ngAfterViewInit(): void {
    if (!this.gstarExpandCollapse.isExpanded) {
      this.el.nativeElement.style.height = 0;
      this.el.nativeElement.style.overflow = 'hidden';
    } else {
      this.el.nativeElement.style.height = 'auto';
      this.el.nativeElement.style.overflow = 'visible';
    }

    this.gstarExpandCollapse.changed.subscribe((_isExpanded: boolean) => {
      if (this.gstarExpandCollapse.isExpanded) {
        this.expand();
      } else {
        this.collapse();
      }
    });
  }

  collapse(): void {
    const currentHeight: number =
      this.el.nativeElement.children[0].clientHeight;
    this.el.nativeElement.style.overflow = 'hidden';
    const factory = this.builder.build(collapseAnimation(currentHeight));
    const player = factory.create(this.el.nativeElement);
    player.onDone(() => {
      this.el.nativeElement.style.height = '0px';
      player.destroy();
    });
    player.play();
  }

  expand(): void {
    const currentHeight: number =
      this.el.nativeElement.children[0].clientHeight;
    this.el.nativeElement.style.overflow = 'hidden';
    const factory = this.builder.build(expandAnimation(currentHeight));
    const player = factory.create(this.el.nativeElement);
    player.onDone(() => {
      this.el.nativeElement.style.height = 'auto';
      this.el.nativeElement.style.overflow = 'visible';
      player.destroy();
    });
    player.play();
  }
}
